import cn from 'classnames'
import React, { ComponentProps } from 'react'

export type ApiKeyUpsellSvgProps = {
  className?: string
} & ComponentProps<'svg'>
export default function ApiKeyUpsellSvg(props: ApiKeyUpsellSvgProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('ApiKeyUpsellSvg', className)}
      width="252"
      height="226"
      viewBox="0 0 252 226"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <g filter="url(#filter0_d_18702_102941)">
        <path
          d="M145.333 153.333V200.667C145.333 204.717 148.616 208 152.666 208H178.666"
          stroke="#223C66"
          strokeWidth="6.66667"
        />
        <path
          d="M223.667 175.333V202.667"
          stroke="#223C66"
          strokeWidth="6.66667"
        />
        <path
          d="M82.6667 152.667V171C82.6667 175.05 79.3834 178.333 75.3333 178.333H48.3333C44.2833 178.333 41 181.617 41 185.667V204.333"
          stroke="#223C66"
          strokeWidth="6.66667"
          strokeLinecap="round"
        />
        <path
          d="M111.333 152.667L111.333 202.667"
          stroke="#223C66"
          strokeWidth="6.66667"
        />
        <circle cx="40.333" cy="207.667" r="9" fill="#BFDEF3" />
        <circle cx="181" cy="207.667" r="9" fill="#BFDEF3" />
        <circle cx="110.667" cy="206" r="10.6667" fill="#BFDEF3" />
        <circle cx="224" cy="206" r="10.6667" fill="#BFDEF3" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.4667 142.175C18.7752 142.175 2 125.368 2 104.638C2 83.9085 18.7752 67.1061 39.4667 67.1061C41.0035 67.1061 42.5089 67.2239 43.9986 67.4046C43.1989 63.7598 42.752 59.9814 42.752 56.0931C42.752 26.9541 66.3289 3.33337 95.4139 3.33337C121.139 3.33337 142.521 21.8207 147.127 46.2465C150.561 44.7187 154.356 43.8507 158.359 43.8507C172.221 43.8507 183.673 54.0625 185.711 67.381C204.337 69.553 218.803 85.3931 218.803 104.638C218.803 125.368 202.028 142.175 181.336 142.175H39.4667Z"
          fill="#BFDEF3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.414 155.782C26.7224 155.782 9.94727 138.976 9.94727 118.246C9.94727 97.5161 26.7224 80.7138 47.414 80.7138C48.9508 80.7138 50.4562 80.8316 51.9459 81.0123C51.1462 77.3674 50.6992 73.5891 50.6992 69.7007C50.6992 40.5617 74.2762 16.941 103.361 16.941C129.087 16.941 150.468 35.4283 155.074 59.8542C158.509 58.3264 162.304 57.4583 166.306 57.4583C180.169 57.4583 191.62 67.6702 193.658 80.9887C212.284 83.1607 226.75 99.0008 226.75 118.246C226.75 138.976 209.975 155.782 189.283 155.782H47.414Z"
          fill="#223C66"
          fillOpacity="0.2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.997 156.48C35.3054 156.48 18.5303 139.673 18.5303 118.943C18.5303 98.2135 35.3054 81.4112 55.997 81.4112C57.5338 81.4112 59.0392 81.529 60.5289 81.7097C59.7292 78.0648 59.2822 74.2865 59.2822 70.3981C59.2822 41.2591 82.8592 17.6384 111.944 17.6384C137.67 17.6384 159.051 36.1257 163.657 60.5516C167.092 59.0237 170.887 58.1557 174.889 58.1557C188.752 58.1557 200.203 68.3675 202.242 81.6861C220.867 83.8581 235.333 99.6982 235.333 118.943C235.333 139.673 218.558 156.48 197.866 156.48H55.997Z"
          fill="#223C66"
        />
        <circle
          cx="200.334"
          cy="147.667"
          r="41.6667"
          fill="url(#paint0_linear_18702_102941)"
        />
        <path
          d="M189.667 134.667L177.61 146.724C177.089 147.245 177.089 148.089 177.61 148.61L189.667 160.667"
          stroke="white"
          strokeWidth="4.66667"
          strokeLinecap="round"
        />
        <path
          d="M212 134.667L224.057 146.724C224.578 147.245 224.578 148.089 224.057 148.609L212 160.667"
          stroke="white"
          strokeWidth="4.66667"
          strokeLinecap="round"
        />
        <path
          d="M205 135L197.667 161.667"
          stroke="white"
          strokeWidth="4.66667"
          strokeLinecap="round"
        />
      </g>
      <path
        d="M77.4 119.667C77.1511 119.667 76.9178 119.573 76.7 119.387C76.5133 119.169 76.42 118.936 76.42 118.687C76.42 118.531 76.4356 118.391 76.4667 118.267L87.4333 88.3067C87.5267 87.9645 87.7133 87.669 87.9933 87.4201C88.3044 87.1401 88.7244 87.0001 89.2533 87.0001H96.16C96.6889 87.0001 97.0933 87.1401 97.3733 87.4201C97.6844 87.669 97.8867 87.9645 97.98 88.3067L108.9 118.267C108.962 118.391 108.993 118.531 108.993 118.687C108.993 118.936 108.884 119.169 108.667 119.387C108.48 119.573 108.247 119.667 107.967 119.667H102.227C101.76 119.667 101.402 119.558 101.153 119.34C100.936 119.091 100.796 118.873 100.733 118.687L98.9133 113.927H86.4533L84.68 118.687C84.6178 118.873 84.4778 119.091 84.26 119.34C84.0422 119.558 83.6689 119.667 83.14 119.667H77.4ZM88.3667 107.207H97.0467L92.66 94.8867L88.3667 107.207ZM113.838 119.667C113.496 119.667 113.216 119.558 112.998 119.34C112.781 119.122 112.672 118.842 112.672 118.5V88.1667C112.672 87.8245 112.781 87.5445 112.998 87.3267C113.216 87.109 113.496 87.0001 113.838 87.0001H126.905C129.487 87.0001 131.727 87.4045 133.625 88.2134C135.554 88.9912 137.047 90.1734 138.105 91.7601C139.194 93.3467 139.738 95.3534 139.738 97.7801C139.738 100.176 139.194 102.151 138.105 103.707C137.047 105.262 135.554 106.413 133.625 107.16C131.727 107.907 129.487 108.28 126.905 108.28H121.352V118.5C121.352 118.842 121.227 119.122 120.978 119.34C120.761 119.558 120.481 119.667 120.138 119.667H113.838ZM121.212 101.84H126.672C128.009 101.84 129.067 101.498 129.845 100.813C130.654 100.129 131.058 99.0867 131.058 97.6867C131.058 96.5045 130.716 95.509 130.032 94.7001C129.347 93.8912 128.227 93.4867 126.672 93.4867H121.212V101.84ZM145.375 119.667C145.033 119.667 144.753 119.558 144.535 119.34C144.317 119.122 144.208 118.842 144.208 118.5V88.1667C144.208 87.8245 144.317 87.5445 144.535 87.3267C144.753 87.109 145.033 87.0001 145.375 87.0001H151.628C151.97 87.0001 152.25 87.109 152.468 87.3267C152.686 87.5445 152.795 87.8245 152.795 88.1667V118.5C152.795 118.842 152.686 119.122 152.468 119.34C152.25 119.558 151.97 119.667 151.628 119.667H145.375Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_18702_102941"
          x="0"
          y="4.07696e-05"
          width="252"
          height="225.333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="2.66667" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_102941"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_102941"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_18702_102941"
          x1="232.334"
          y1="113.333"
          x2="179"
          y2="189.333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01D0B4" />
          <stop offset="1" stopColor="#4186F6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
